import React from 'react'
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './BannerSlider.css'


import Image5 from '../Components/Images/banner/ban2.png'

import Image7 from '../Components/Images/banner/ban4.png'

import Image9 from '../Components/Images/banner/ban20.png'
import Image10 from '../Components/Images/banner/ban11.png'
import Image11 from '../Components/Images/banner/ban12.png'
import Image12 from '../Components/Images/banner/ban_13.png'
import Image13 from '../Components/Images/banner/ban_14.png'
import Image14 from '../Components/Images/banner/bantest1.png'
import Image15 from '../Components/Images/banner/bantest2.png'
import Image16 from '../Components/Images/banner/bantest3.png'
import Image17 from '../Components/Images/banner/bantest4.png'
import Image18 from '../Components/Images/banner/bantest5.png'
import Image19 from '../Components/Images/banner/bantest6.png'

function Slide() {
    const settings = {
        dots: true, // Show dot indicators
        infinite: true, // Infinite looping
        speed: 500, // Transition speed
        slidesToShow: 1, // Number of slides to show at a time
        slidesToScroll: 1, // Number of slides to scroll
        autoplay: true, // Auto-play the slider
        autoplaySpeed: 4000, // Auto-play speed in milliseconds
        lazyLoad: 'ondemand',
        arrows:true,
        responsive: [
          {
            breakpoint: 768, // Mobile breakpoint
            settings: {
              arrows: false, // Hide arrows on mobile
            },
          },
        ],
      };

      const bannerImages = [
        Image5, Image7, Image9, Image10, Image11, Image12, Image13, Image14, Image15, Image16, Image17, Image18, Image19
      ];
  return (
    <div>
      <section>
    <div className='' style={{marginTop:"0px"}}>

    <div className="banner-slider">
      <Slider {...settings}>
        {bannerImages.map((image, index) => (
          <div key={index}>
            <img
              src={image}
              alt={`Banner ${index + 1}`}
              className="img-fluid w-100" // Bootstrap class for responsive images
              style={{borderRadius:"0px"}}
            />
          </div>
        ))}
      </Slider>
    </div>
</div>

    </section>
    </div>
  )
}

export default Slide
